import React from 'react';
import PropTypes from 'prop-types';
import { SovosDialog, SovosDialogActions, SovosDialogContent } from 's1-ui/sovos-dialog';
import SovosFlatButton from 's1-ui/sovos-flat-button/SovosFlatButton';

const InvoiceDialog = props => (
  <SovosDialog
    open={ props.open }
    onClose={ props.onClose }
    width="medium"
  >
    <SovosDialogContent style={ { fontSize: 16 } }>
      { props.message }
    </SovosDialogContent>
    <SovosDialogActions>
      <SovosFlatButton 
        color="secondary"
        onClick={ props.onClose }
      >
        { props.cancelButton }
      </SovosFlatButton>
      {
        props.okButton &&
              <SovosFlatButton 
                color="secondary"
                onClick={ props.onContinue }
              >
                { props.okButton }
              </SovosFlatButton>
      }
    </SovosDialogActions>
  </SovosDialog>
);

InvoiceDialog.propTypes = { 
  open: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onContinue: PropTypes.func,
  cancelButton: PropTypes.string,
  okButton: PropTypes.string
};

export default InvoiceDialog;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/InvoiceDialog/InvoiceDialog.js